import './styles.scss';

import React from 'react';

import { useTheme } from '../../context/ThemeProvider';

interface IBottomSheetTileProps {
  icon: React.ReactNode | string;
  title: string;
  description?: string;
  alignIcon?: 'center' | 'flex-start';
  onClick: () => void;
  warning?: boolean;
  color?: string;
}

const BottomSheetTile: React.FC<IBottomSheetTileProps> = ({
  icon,
  title,
  description,
  alignIcon = 'center',
  onClick,
  warning = false,
  color,
}) => {
  const { colors } = useTheme();
  return (
    <li className="dropdownListItem" onClick={onClick}>
      <div className="dropdownItem" style={{ alignItems: alignIcon }}>
        <div
          className="icon"
          style={{
            color: (warning && colors.DANGER) || color || colors.ICON,
            backgroundColor:
              (warning && `${colors.DANGER}0d`) ||
              (color && `${color}0d`) ||
              colors.TERTIARY,
          }}>
          {icon && typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
        </div>
        <div className="details">
          <h3
            className="title"
            style={{ color: warning ? colors.DANGER : color || colors.TEXT1 }}>
            {title}
          </h3>
          {description ? <p className="subtitle">{description}</p> : null}
        </div>
      </div>
    </li>
  );
};

export default React.memo(BottomSheetTile);
